import { genComponentStyleHook, type FullToken } from '../geek/styleUtil'
import { cyan, space, transition } from './neonUtil'
import { DOT_PREFIX } from './constant'

const focusGlow = `0 0 0 1px ${cyan[500]}20, 0 0 4px ${cyan[500]}10 !important`

export default genComponentStyleHook(['Select', 'cyberTheme'], (token: FullToken) => {
  const { componentCls } = token

  return {
    [`${componentCls}${DOT_PREFIX}`]: {
      [`${componentCls}-selector`]: {
        borderRadius: '2px !important',
        background: `${space[800]} !important`,
        borderColor: `${cyan[500]}20 !important`,
        transition,
      },

      '&:hover': {
        [`${componentCls}-selector`]: {
          borderColor: `${cyan[500]}50 !important`,
        },
      },

      [`&${componentCls}-focused`]: {
        [`${componentCls}-selector`]: {
          borderColor: `${cyan[500]}80 !important`,
          boxShadow: focusGlow,
        },
      },

      // 下拉箭头
      [`${componentCls}-arrow`]: {
        color: `${cyan[600]} !important`,
      },

      // 清除按钮
      [`${componentCls}-clear`]: {
        background: `${space[800]} !important`,
        color: `${cyan[600]} !important`,
        '&:hover': {
          color: `${cyan[400]} !important`,
        },
      },
    },
  }
})
